import React from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "../ProductListScreen.css";

export default function DeleteModal(props) {
  const {
    showConfirmModal,
    setShowConfirmModal,
    deleteHandler,
    objectToDelete,
    title,
    message,
  } = props;

  return (
    <Modal
      show={showConfirmModal}
      onHide={() => setShowConfirmModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
          Vazgeç
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            setShowConfirmModal(false);
            deleteHandler(objectToDelete);
          }}
        >
          Sil
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
